export default "__VITE_ASSET__BtRZ5ZRM__"